import React, { useEffect, useState } from 'react';

const CursorFollower = () => {
    const [position, setPosition] = useState({ x: -100, y: -100 });
    const [hidden, setHidden] = useState(true);
    const [clicked, setClicked] = useState(false);

    useEffect(() => {
        const moveCursor = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
            setHidden(false);
        };

        const handleMouseDown = () => setClicked(true);
        const handleMouseUp = () => setClicked(false);
        const handleMouseLeave = () => setHidden(true);
        const handleMouseEnter = () => setHidden(false);

        window.addEventListener('mousemove', moveCursor);
        window.addEventListener('mousedown', handleMouseDown);
        window.addEventListener('mouseup', handleMouseUp);
        document.body.addEventListener('mouseleave', handleMouseLeave);
        document.body.addEventListener('mouseenter', handleMouseEnter);

        return () => {
            window.removeEventListener('mousemove', moveCursor);
            window.removeEventListener('mousedown', handleMouseDown);
            window.removeEventListener('mouseup', handleMouseUp);
            document.body.removeEventListener('mouseleave', handleMouseLeave);
            document.body.removeEventListener('mouseenter', handleMouseEnter);
        };
    }, []);

    const cursorStyle = {
        position: 'fixed',
        left: 0,
        top: 0,
        width: '400px',
        height: '400px',
        margin: '-200px 0 0 -200px',
        pointerEvents: 'none',
        zIndex: 9999,
        background: 'radial-gradient(circle, rgba(255, 107, 53, 0.08) 0%, rgba(59, 130, 246, 0.05) 30%, transparent 70%)',
        transform: `translate3d(${position.x}px, ${position.y}px, 0) scale(${clicked ? 0.9 : 1})`,
        transition: 'transform 0.1s cubic-bezier(0.165, 0.84, 0.44, 1), opacity 0.3s ease',
        opacity: hidden ? 0 : 1,
        mixBlendMode: 'screen'
    };

    const dotStyle = {
        position: 'fixed',
        left: 0,
        top: 0,
        width: '8px',
        height: '8px',
        margin: '-4px 0 0 -4px',
        borderRadius: '50%',
        backgroundColor: clicked ? '#ff6b35' : 'rgba(255, 255, 255, 0.8)',
        pointerEvents: 'none',
        zIndex: 10000,
        transform: `translate3d(${position.x}px, ${position.y}px, 0)`,
        transition: 'backgroundColor 0.2s ease, transform 0.05s linear',
        opacity: hidden ? 0 : 1,
        boxShadow: `0 0 10px ${clicked ? '#ff6b35' : 'rgba(255,255,255,0.5)'}`
    };

    return (
        <>
            <div style={cursorStyle} />
            <div style={dotStyle} />
        </>
    );
};

export default CursorFollower;
